// Material Dashboard 2 PRO React layouts
import Analytics from "layouts/dashboards/analytics";
import Sales from "layouts/dashboards/sales";
import ProfileOverview from "layouts/pages/profile/profile-overview";
import AllProjects from "layouts/pages/profile/all-projects";
import NewUser from "layouts/pages/users/new-user";
import Settings from "layouts/pages/account/settings";
import Billing from "layouts/pages/account/billing";
import Invoice from "layouts/pages/account/invoice";
import Timeline from "layouts/pages/projects/timeline";
import PricingPage from "layouts/pages/pricing-page";
import Widgets from "layouts/pages/widgets";
import RTL from "layouts/pages/rtl";
import Charts from "layouts/pages/charts";
import Notifications from "layouts/pages/notifications";
import Kanban from "layouts/applications/kanban";
import Wizard from "layouts/applications/wizard";
import DataTables from "layouts/applications/data-tables";
import Calendar from "layouts/applications/calendar";
import NewProduct from "layouts/ecommerce/products/new-product";
import EditProduct from "layouts/ecommerce/products/edit-product";
import ProductPage from "layouts/ecommerce/products/product-page";
import OrderList from "layouts/ecommerce/orders/order-list";
import OrderDetails from "layouts/ecommerce/orders/order-details";
import SignInBasic from "layouts/authentication/sign-in/basic";
import SignInCover from "layouts/authentication/sign-in/cover";
import SignInIllustration from "layouts/authentication/sign-in/illustration";
import SignUpCover from "layouts/authentication/sign-up/cover";
import ResetCover from "layouts/authentication/reset-password/cover";

// @mui icons
import Icon from "@mui/material/Icon";

// Images
import profilePicture from "assets/images/team-3.jpg";
import MemberList from "layouts/management/members/member-list";
import PopupList from "layouts/management/popup/popup-list";
import RequestList from "layouts/management/point/request";

import InquiryList from "layouts/management/inquiry/inquiry-list";
import ConsultationList from "layouts/management/consultation";
import ConsultationDetail from "layouts/management/consultation/detail";
import StrategyList from "layouts/management/strategy";
import StrategyDetail from "layouts/management/strategy/detail";

import NoticeList from "layouts/management/notice/list";
import NoticeCreate from "layouts/management/notice/create";
import LogList from "layouts/management/log/log-list";
import LandingPageList from "layouts/management/landing-page";
import LandingPageList2 from "layouts/management/landing2";
import LandingPageList3 from "layouts/management/landing3";
import SignupList from "layouts/management/dashboard";
import Dashboard from "layouts/management/dashboard";
import Landing from "layouts/management/landing/Landing";
import Sale from "layouts/management/sales/Sales";
import BrokerList from "layouts/management/brokers/brokerList/BrokerList";
import ColletionList from "layouts/IdleLand/IdleLand";
import SaleItemList from "layouts/saleItems/SaleItems";
import Promotion from "layouts/management/promotion";
import Payment from "layouts/management/payment";
import PaymentLog from "layouts/management/paymentLog";
import Coupon from "layouts/management/coupon";
import CouponIssue from "layouts/management/couponIssue";
import CouponIssueList from "layouts/management/couponIssueList";
import ShareLog from "layouts/management/share";

const routes = [
  {
    type: "collapse",
    name: "회원 관리",
    key: "members",
    icon: <Icon fontSize="small">groups_3</Icon>,
    route: "/management/members/member-list",
    component: <MemberList />,
    noCollapse: true,
  },
  // {
  //   type: "collapse",
  //   name: "중개사 관리",
  //   key: "brokers",
  //   icon: <Icon fontSize="small">handshake</Icon>,
  //   route: "/management/brokers/brokers-list",
  //   component: <BrokerList />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "매물 관리",
  //   key: "saleItems",
  //   icon: <Icon fontSize="small">real_estate_agent</Icon>,
  //   route: "/management/SaleItems/saleItem-list",
  //   component: <SaleItemList />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "DB수집",
  //   key: "DB",
  //   icon: <Icon fontSize="small">storage</Icon>,
  //   route: "/DataBaseCollection/collection-list",
  //   component: <ColletionList />,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "고객 문의",
    key: "inquiry",
    icon: <Icon fontSize="small">message</Icon>,
    route: "/management/inquiry/inquiry-list",
    component: <InquiryList />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "상담신청 내역",
    key: "consultation",
    icon: <Icon fontSize="small">support_agent</Icon>,
    route: "/management/consultation",
    component: <ConsultationList />,
    noCollapse: true,
  },
  {
    type: "route",
    name: "Consultation Detail",
    key: "consultation-detail",
    route: "/management/consultation/:id",
    component: <ConsultationDetail />,
  },
  {
    type: "collapse",
    name: "맞춤전략 신청",
    key: "strategy",
    icon: <Icon fontSize="small">insights</Icon>,
    route: "/management/strategy",
    component: <StrategyList />,
    noCollapse: true,
  },
  {
    type: "route",
    name: "Strategy Detail",
    key: "strategy-detail",
    route: "/management/strategy/:id",
    component: <StrategyDetail />,
  },
  {
    type: "collapse",
    name: "결제 내역",
    key: "payment",
    icon: <Icon fontSize="small">credit_card</Icon>,
    route: "/management/payment",
    component: <Payment />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "결제 로그",
    key: "paymentLog",
    icon: <Icon fontSize="small">credit_card</Icon>,
    route: "/management/payment-log",
    component: <PaymentLog />,
    noCollapse: true,
  },
  // {
  //   type: "collapse",
  //   name: "매출 현황",
  //   key: "sale",
  //   icon: <Icon fontSize="small">wallet</Icon>,
  //   route: "/management/sales",
  //   component: <Sale />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "충전/포인트 관리",
  //   key: "points",
  //   icon: <Icon fontSize="small">credit_card</Icon>,
  //   route: "/management/point/request-list",
  //   component: <RequestList />,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "프로모션",
    key: "promotion",
    icon: <Icon fontSize="small">celebration</Icon>,
    route: "/management/promotion",
    component: <Promotion />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "쿠폰",
    key: "coupon",
    icon: <Icon fontSize="small">celebration</Icon>,
    collapse: [
      {
        name: "쿠폰 지급",
        key: "coupon-issue",
        route: "/management/coupon/coupon-issue",
        component: <CouponIssue />,
      },
      {
        name: "쿠폰 지급 목록",
        key: "coupon-issue-list",
        route: "/management/coupon/coupon-issue-list",
        component: <CouponIssueList />,
      },
      {
        name: "쿠폰 리스트",
        key: "coupon-history",
        route: "/management/coupon/coupon-history",
        component: <Coupon />,
      },
    ],
  },
  {
    type: "collapse",
    name: "운영",
    key: "monitoring",
    icon: <Icon fontSize="small">support_agent</Icon>,
    collapse: [
      {
        name: "공지사항",
        key: "notice-list",
        icon: <Icon fontSize="small">support_agent</Icon>,
        route: "/management/notice/notice-list",
        component: <NoticeList />,
      },
      {
        name: "공지등록",
        key: "notice-create",
        icon: <Icon fontSize="small">support_agent</Icon>,
        route: "/management/notice/notice-create",
        component: <NoticeCreate />,
      },
      {
        name: "팝업게시",
        key: "profile-settings",
        icon: <Icon fontSize="small">support_agent</Icon>,
        route: "/management/popups/popup-list",
        component: <PopupList />,
      },
      {
        name: "랜딩",
        key: "landing",
        icon: <Icon fontSize="small">support_agent</Icon>,
        route: "/management/landing",
        component: <Landing />,
      },
    ],
  },
  {
    type: "collapse",
    name: "공유 로그",
    key: "share",
    icon: <Icon fontSize="small">share</Icon>,
    route: "/management/sharelog",
    component: <ShareLog />,
    noCollapse: true,
  },
  {
    type: "route",
    name: "Notice Update",
    key: "notice-update",
    icon: <Icon fontSize="medium">C</Icon>,
    route: "/management/notice/notice-update/:idx",
    component: <NoticeCreate />,
  },
  {
    type: "route",
    name: "Dashboard",
    key: "dashboard",
    route: "/management/dashboard",
    component: <Dashboard />,
  },
  {
    type: "route",
    name: "Account",
    key: "account",
    route: "/management/Account",
    component: <Settings />,
  },
  {
    type: "route",
    name: "Logout",
    key: "logout",
    route: "/authentication/sign-in/basic",
    component: <SignInBasic />,
  },
  // {
  //   type: "collapse",
  //   name: "",
  //   key: "brooklyn-alice",
  //   collapse: [
  //     {
  //       name: "My Profile",
  //       key: "my-profile",
  //       route: "/pages/profile/profile-overview",
  //       component: <ProfileOverview />,
  //     },
  //     {
  //       name: "Settings",
  //       key: "profile-settings",
  //       route: "/pages/account/settings",
  //       component: <Settings />,
  //     },
  //     {
  //       name: "Logout",
  //       key: "logout",
  //       route: "/authentication/sign-in/basic",
  //       component: <SignInBasic />,
  //     },
  //   ],
  // },
  // {
  //   type: "collapse",
  //   name: "Monitoring",
  //   key: "monitoring",
  //   icon: <Icon fontSize="medium">person</Icon>,
  //   collapse: [
  //     {
  //       name: "Signup",
  //       key: "sign",
  //       icon: <Icon fontSize="medium">person</Icon>,
  //       route: "/management/signup/signup-list",
  //       component: <SignupList />,
  //     },
  //     {
  //       name: "Log",
  //       key: "log",
  //       icon: <Icon fontSize="medium">person</Icon>,
  //       route: "/management/log/log-list",
  //       component: <LogList />,
  //     },
  //   ],
  // },
  // {
  //   type: "collapse",
  //   name: "Notice",
  //   icon: <Icon fontSize="medium">campaign</Icon>,
  //   key: "notice",
  //   collapse: [
  //     {
  //       name: "Notice List",
  //       key: "notice-list",
  //       icon: <Icon fontSize="medium">L</Icon>,
  //       route: "/management/notice/notice-list",
  //       component: <NoticeList />,
  //     },
  //     {
  //       name: "Notice Create",
  //       key: "notice-create",
  //       icon: <Icon fontSize="medium">C</Icon>,
  //       route: "/management/notice/notice-create",
  //       component: <NoticeCreate />,
  //     },
  //   ],
  // },

  // {
  //   type: "collapse",
  //   name: "Popup",
  //   key: "popups",
  //   icon: <Icon fontSize="medium">ad_units</Icon>,
  //   route: "/management/popups/popup-list",
  //   component: <PopupList />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Inquiry",
  //   key: "inquiry",
  //   icon: <Icon fontSize="medium">paid</Icon>,
  //   route: "/management/inquiry/inquiry-list",
  //   component: <InquiryList />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "LandingPage",
  //   key: "landing-page",
  //   icon: <Icon fontSize="medium">dashboard</Icon>,
  //   route: "/management/landing-page",
  //   component: <LandingPageList />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "LandingPage",
  //   icon: <Icon fontSize="medium">dashboard</Icon>,
  //   key: "landing-page",
  //   collapse: [
  //     {
  //       name: "LandingPage",
  //       key: "landing-page",
  //       icon: <Icon fontSize="medium">L</Icon>,
  //       route: "/management/landing-page",
  //       component: <LandingPageList />,
  //     },
  //     {
  //       name: "가격분석 랜딩페이지",
  //       key: "landing-page-price",
  //       icon: <Icon fontSize="medium">P</Icon>,
  //       route: "/management/landing-page2",
  //       component: <LandingPageList2 />,
  //     },
  //     {
  //       name: "농지연금 랜딩페이지",
  //       key: "landing-page-pension",
  //       icon: <Icon fontSize="medium">P</Icon>,
  //       route: "/management/landing-page3",
  //       component: <LandingPageList3 />,
  //     },
  //   ],
  // },
  // {
  //   type: "collapse",
  //   name: "Dashboards",
  //   key: "dashboards",
  //   icon: <Icon fontSize="medium">dashboard</Icon>,
  //   collapse: [
  //     {
  //       name: "Analytics",
  //       key: "analytics",
  //       route: "/dashboards/analytics",
  //       component: <Analytics />,
  //     },
  //     {
  //       name: "Sales",
  //       key: "sales",
  //       route: "/dashboards/sales",
  //       component: <Sales />,
  //     },
  //   ],
  // },
  // { type: "title", title: "Pages", key: "title-pages" },
  // {
  //   type: "collapse",
  //   name: "Pages",
  //   key: "pages",
  //   icon: <Icon fontSize="medium">image</Icon>,
  //   collapse: [
  //     {
  //       name: "Profile",
  //       key: "profile",
  //       collapse: [
  //         {
  //           name: "Profile Overview",
  //           key: "profile-overview",
  //           route: "/pages/profile/profile-overview",
  //           component: <ProfileOverview />,
  //         },
  //         {
  //           name: "All Projects",
  //           key: "all-projects",
  //           route: "/pages/profile/all-projects",
  //           component: <AllProjects />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Users",
  //       key: "users",
  //       collapse: [
  //         {
  //           name: "New User",
  //           key: "new-user",
  //           route: "/pages/users/new-user",
  //           component: <NewUser />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Account",
  //       key: "account",
  //       collapse: [
  //         {
  //           name: "Settings",
  //           key: "settings",
  //           route: "/pages/account/settings",
  //           component: <Settings />,
  //         },
  //         {
  //           name: "Billing",
  //           key: "billing",
  //           route: "/pages/account/billing",
  //           component: <Billing />,
  //         },
  //         {
  //           name: "Invoice",
  //           key: "invoice",
  //           route: "/pages/account/invoice",
  //           component: <Invoice />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Projects",
  //       key: "projects",
  //       collapse: [
  //         {
  //           name: "Timeline",
  //           key: "timeline",
  //           route: "/pages/projects/timeline",
  //           component: <Timeline />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Pricing Page",
  //       key: "pricing-page",
  //       route: "/pages/pricing-page",
  //       component: <PricingPage />,
  //     },
  //     { name: "RTL", key: "rtl", route: "/pages/rtl", component: <RTL /> },
  //     { name: "Widgets", key: "widgets", route: "/pages/widgets", component: <Widgets /> },
  //     { name: "Charts", key: "charts", route: "/pages/charts", component: <Charts /> },
  //     {
  //       name: "Notfications",
  //       key: "notifications",
  //       route: "/pages/notifications",
  //       component: <Notifications />,
  //     },
  //   ],
  // },
  // {
  //   type: "collapse",
  //   name: "Applications",
  //   key: "applications",
  //   icon: <Icon fontSize="medium">apps</Icon>,
  //   collapse: [
  //     {
  //       name: "Kanban",
  //       key: "kanban",
  //       route: "/applications/kanban",
  //       component: <Kanban />,
  //     },
  //     {
  //       name: "Wizard",
  //       key: "wizard",
  //       route: "/applications/wizard",
  //       component: <Wizard />,
  //     },
  //     {
  //       name: "Data Tables",
  //       key: "data-tables",
  //       route: "/applications/data-tables",
  //       component: <DataTables />,
  //     },
  //     {
  //       name: "Calendar",
  //       key: "calendar",
  //       route: "/applications/calendar",
  //       component: <Calendar />,
  //     },
  //   ],
  // },
  // {
  //   type: "collapse",
  //   name: "Ecommerce",
  //   key: "ecommerce",
  //   icon: <Icon fontSize="medium">shopping_basket</Icon>,
  //   collapse: [
  //     {
  //       name: "Products",
  //       key: "products",
  //       collapse: [
  //         {
  //           name: "New Product",
  //           key: "new-product",
  //           route: "/ecommerce/products/new-product",
  //           component: <NewProduct />,
  //         },
  //         {
  //           name: "Edit Product",
  //           key: "edit-product",
  //           route: "/ecommerce/products/edit-product",
  //           component: <EditProduct />,
  //         },
  //         {
  //           name: "Product Page",
  //           key: "product-page",
  //           route: "/ecommerce/products/product-page",
  //           component: <ProductPage />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Orders",
  //       key: "orders",
  //       collapse: [
  //         {
  //           name: "Order List",
  //           key: "order-list",
  //           route: "/ecommerce/orders/order-list",
  //           component: <OrderList />,
  //         },
  //         {
  //           name: "Order Details",
  //           key: "order-details",
  //           route: "/ecommerce/orders/order-details",
  //           component: <OrderDetails />,
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   type: "collapse",
  //   name: "Authentication",
  //   key: "authentication",
  //   icon: <Icon fontSize="medium">content_paste</Icon>,
  //   collapse: [
  //     {
  //       name: "Sign In",
  //       key: "sign-in",
  //       collapse: [
  //         {
  //           name: "Basic",
  //           key: "basic",
  //           route: "/authentication/sign-in/basic",
  //           component: <SignInBasic />,
  //         },
  //         {
  //           name: "Cover",
  //           key: "cover",
  //           route: "/authentication/sign-in/cover",
  //           component: <SignInCover />,
  //         },
  //         {
  //           name: "Illustration",
  //           key: "illustration",
  //           route: "/authentication/sign-in/illustration",
  //           component: <SignInIllustration />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Sign Up",
  //       key: "sign-up",
  //       collapse: [
  //         {
  //           name: "Cover",
  //           key: "cover",
  //           route: "/authentication/sign-up/cover",
  //           component: <SignUpCover />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Reset Password",
  //       key: "reset-password",
  //       collapse: [
  //         {
  //           name: "Cover",
  //           key: "cover",
  //           route: "/authentication/reset-password/cover",
  //           component: <ResetCover />,
  //         },
  //       ],
  //     },
  //   ],
  // },
  // { type: "divider", key: "divider-1" },
  // { type: "title", title: "Docs", key: "title-docs" },
  // {
  //   type: "collapse",
  //   name: "Basic",
  //   key: "basic",
  //   icon: <Icon fontSize="medium">upcoming</Icon>,
  //   collapse: [
  //     {
  //       name: "Getting Started",
  //       key: "getting-started",
  //       collapse: [
  //         {
  //           name: "Overview",
  //           key: "overview",
  //           href: "https://www.creative-tim.com/learning-lab/react/overview/material-dashboard/",
  //         },
  //         {
  //           name: "License",
  //           key: "license",
  //           href: "https://www.creative-tim.com/learning-lab/react/license/material-dashboard/",
  //         },
  //         {
  //           name: "Quick Start",
  //           key: "quick-start",
  //           href: "https://www.creative-tim.com/learning-lab/react/quick-start/material-dashboard/",
  //         },
  //         {
  //           name: "Build Tools",
  //           key: "build-tools",
  //           href: "https://www.creative-tim.com/learning-lab/react/build-tools/material-dashboard/",
  //         },
  //       ],
  //     },
  //     {
  //       name: "Foundation",
  //       key: "foundation",
  //       collapse: [
  //         {
  //           name: "Colors",
  //           key: "colors",
  //           href: "https://www.creative-tim.com/learning-lab/react/colors/material-dashboard/",
  //         },
  //         {
  //           name: "Grid",
  //           key: "grid",
  //           href: "https://www.creative-tim.com/learning-lab/react/grid/material-dashboard/",
  //         },
  //         {
  //           name: "Typography",
  //           key: "base-typography",
  //           href: "https://www.creative-tim.com/learning-lab/react/base-typography/material-dashboard/",
  //         },
  //         {
  //           name: "Borders",
  //           key: "borders",
  //           href: "https://www.creative-tim.com/learning-lab/react/borders/material-dashboard/",
  //         },
  //         {
  //           name: "Box Shadows",
  //           key: "box-shadows",
  //           href: "https://www.creative-tim.com/learning-lab/react/box-shadows/material-dashboard/",
  //         },
  //         {
  //           name: "Functions",
  //           key: "functions",
  //           href: "https://www.creative-tim.com/learning-lab/react/functions/material-dashboard/",
  //         },
  //         {
  //           name: "Routing System",
  //           key: "routing-system",
  //           href: "https://www.creative-tim.com/learning-lab/react/routing-system/material-dashboard/",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   type: "collapse",
  //   name: "Components",
  //   key: "components",
  //   icon: <Icon fontSize="medium">view_in_ar</Icon>,
  //   collapse: [
  //     {
  //       name: "Alerts",
  //       key: "alerts",
  //       href: "https://www.creative-tim.com/learning-lab/react/alerts/material-dashboard/",
  //     },
  //     {
  //       name: "Avatar",
  //       key: "avatar",
  //       href: "https://www.creative-tim.com/learning-lab/react/avatar/material-dashboard/",
  //     },
  //     {
  //       name: "Badge",
  //       key: "badge",
  //       href: "https://www.creative-tim.com/learning-lab/react/badge/material-dashboard/",
  //     },
  //     {
  //       name: "Badge Dot",
  //       key: "badge-dot",
  //       href: "https://www.creative-tim.com/learning-lab/react/badge-dot/material-dashboard/",
  //     },
  //     {
  //       name: "Box",
  //       key: "box",
  //       href: "https://www.creative-tim.com/learning-lab/react/box/material-dashboard/",
  //     },
  //     {
  //       name: "Buttons",
  //       key: "buttons",
  //       href: "https://www.creative-tim.com/learning-lab/react/buttons/material-dashboard/",
  //     },
  //     {
  //       name: "Date Picker",
  //       key: "date-picker",
  //       href: "https://www.creative-tim.com/learning-lab/react/datepicker/material-dashboard/",
  //     },
  //     {
  //       name: "Dropzone",
  //       key: "dropzone",
  //       href: "https://www.creative-tim.com/learning-lab/react/dropzone/material-dashboard/",
  //     },
  //     {
  //       name: "Editor",
  //       key: "editor",
  //       href: "https://www.creative-tim.com/learning-lab/react/quill/material-dashboard/",
  //     },
  //     {
  //       name: "Input",
  //       key: "input",
  //       href: "https://www.creative-tim.com/learning-lab/react/input/material-dashboard/",
  //     },
  //     {
  //       name: "Pagination",
  //       key: "pagination",
  //       href: "https://www.creative-tim.com/learning-lab/react/pagination/material-dashboard/",
  //     },
  //     {
  //       name: "Progress",
  //       key: "progress",
  //       href: "https://www.creative-tim.com/learning-lab/react/progress/material-dashboard/",
  //     },
  //     {
  //       name: "Snackbar",
  //       key: "snackbar",
  //       href: "https://www.creative-tim.com/learning-lab/react/snackbar/material-dashboard/",
  //     },
  //     {
  //       name: "Social Button",
  //       key: "social-button",
  //       href: "https://www.creative-tim.com/learning-lab/react/social-buttons/material-dashboard/",
  //     },
  //     {
  //       name: "Typography",
  //       key: "typography",
  //       href: "https://www.creative-tim.com/learning-lab/react/typography/material-dashboard/",
  //     },
  //   ],
  // },
  // {
  //   type: "collapse",
  //   name: "Change Log",
  //   key: "changelog",
  //   href: "https://github.com/creativetimofficial/ct-material-dashboard-pro-react/blob/main/CHANGELOG.md",
  //   icon: <Icon fontSize="medium">receipt_long</Icon>,
  //   noCollapse: true,
  // },
];

export default routes;
